import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutation,
	StandardAction
} from '@/shared/utils';
import {LongueursAchat} from '@/models';
import {LongueursAchatService} from '@/xhttp';
import store from '@/stores';

Vue.use(Vuex);

export class LongueursAchatFilter {
	
	public name: string = '';
	
	public toString(): string {
		return JSON.stringify(this);
	}
}

class LongueursAchatState extends PaginatorFilterState<LongueursAchatFilter> {
	public longueursAchat: LongueursAchat = null;
	public longueursAchats: ResultType<LongueursAchat> = null;
	public longueursAchatsAll: ResultType<LongueursAchat> = null;
	public constructor() {
		super(new LongueursAchatFilter(), 'longueursAchats', 'longueursAchat', 'listOrder', AscDesc.ASC, 50);
	}
}

class LongueursAchatStore {
	
	@XHTTPService(() => LongueursAchat)
	private longueursAchatService: LongueursAchatService;
	
	public state: LongueursAchatState = new LongueursAchatState();
	
	public mutations = {
		...PaginatorMutation(() => storeLongueursAchat, 'longueursAchats', 'longueursAchat'),
	};
	
	public actions = {
		...StandardAction<LongueursAchat, LongueursAchatState>(() => LongueursAchat, 'longueursAchat'),
		...PaginatorActionWithFilters<LongueursAchat, LongueursAchatState>(() => LongueursAchat, 'longueursAchats', 'longueursAchat'),
	};
	
}
const instance = new LongueursAchatStore();
const storeLongueursAchat = new Vuex.Store(instance);
store.registerModule('longueursAchat', storeLongueursAchat);
export default storeLongueursAchat;
